import type { DeviceNode } from '../../types';
import { ConditionCard } from '../condition-card';
import { FieldOperatorValue } from '../condition-parts';

export function DeviceCondition({ node }: { node: DeviceNode }) {
  return (
    <ConditionCard node={node}>
      <FieldOperatorValue field={node.field} operator={node.operator} value={node.value} value2={node.value2} />
    </ConditionCard>
  );
}
